import * as THREE from 'three';

import Config from './config';

let config = Config.instance;

class Scene extends THREE.Scene {

	constructor() {

		super()

	}
}

let scene = new Scene();

export default scene;



// WEBPACK FOOTER //
// ./src/scripts/Trail/scene.js